import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'components/Button'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import { BTN_TXT } from '../../../../../constants'
import { InvoicesTableActionsProps } from './types'
import { useFinancialsActionReasonPopup } from 'features/Financials/Providers/FinancialsActionReasonPopupProvider'
import { ActionReasonPopup } from 'features/Financials/Rebates/RebatesTable/InvoicesDetailsPopup/InvoicesDetails/InvoicesTable/ActionReasonPopup/ActionReasonPopup'
import { MODAL_TYPE_TO_DISPUTE } from 'features/Financials/Rebates/RebatesTable/InvoicesDetailsPopup/InvoicesDetails/InvoicesTable/ActionReasonPopup/constants'
import { MODAL_TYPES } from 'features/Financials/Rebates/RebatesTable/InvoicesDetailsPopup/InvoicesDetails/InvoicesTable/ActionReasonPopup/types'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { useFinancialsCognusARContext } from 'features/Financials/Providers/FinancialsCognusARProvider'
import {
  createCognusARDispute,
  marketplaceARRebateCorrelationCheckRequest
} from '../../api'
import { setLoading } from 'redux/store/common/slice'
import './styles.scss'

export const InvoicesTableActions = ({
  totalNumber,
  selectedRowKeys,
  setSelectedRowKeys,
  updateData
}: InvoicesTableActionsProps) => {
  const {
    state: { type },
    actions: { onOpenPopup }
  } = useFinancialsActionReasonPopup()

  const {
    disputeProcessCantBeDonePopup: {
      actions: { open: openDisputeProcessCantBeDonePopup }
    },
    invoicesDetailsPopup: { state }
  } = useFinancialsPopup()
  const { invoiceData } = state.payload
  const {
    actions: { updateCognusARData }
  } = useFinancialsCognusARContext()
  const dispatch = useDispatch()

  const onDisputeActionClick = useCallback(
    async (modalType: MODAL_TYPES) => {
      if (!invoiceData?.uuid) return

      try {
        dispatch(setLoading(true))
        const { data: correlationCheckResponse } =
          await marketplaceARRebateCorrelationCheckRequest(invoiceData.uuid, {
            document_keys: selectedRowKeys
          })
        if (correlationCheckResponse.is_successful) {
          onOpenPopup(modalType)
          return
        }
        openDisputeProcessCantBeDonePopup({
          correlationCheck: correlationCheckResponse
        })
      } finally {
        dispatch(setLoading(false))
      }
    },
    [
      dispatch,
      invoiceData?.uuid,
      onOpenPopup,
      openDisputeProcessCantBeDonePopup,
      selectedRowKeys
    ]
  )

  const onSetDisputeStatus = useCallback(
    async (reason: string) => {
      if (type && type in MODAL_TYPE_TO_DISPUTE && invoiceData?.uuid) {
        await createCognusARDispute(invoiceData.uuid, {
          dispute_reason: reason,
          dispute_type: MODAL_TYPE_TO_DISPUTE[type],
          document_keys: selectedRowKeys
        })
      }
    },
    [invoiceData?.uuid, selectedRowKeys, type]
  )

  return (
    <>
      <div className="invoices-table-actions row space-between align-center">
        <div className="column">
          <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
            Selected {selectedRowKeys.length} of {totalNumber}
          </Typography.Body1>
        </div>
        <div className="row gap-8">
          <Button
            onClick={() =>
              onDisputeActionClick(MODAL_TYPES.EXCLUDE_FORM_REBATE)
            }
            danger
            upperCase
          >
            {BTN_TXT.EXCLUDE}
          </Button>
          <Button
            onClick={() =>
              onDisputeActionClick(MODAL_TYPES.DEFER_TO_NEXT_QUARTER)
            }
            upperCase
          >
            {BTN_TXT.DEFER_TO_NEXT_QUARTER}
          </Button>
        </div>
      </div>
      <ActionReasonPopup
        onSubmit={onSetDisputeStatus}
        setSelectedRowKeys={setSelectedRowKeys}
        updateData={updateData}
        updateDashboard={updateCognusARData}
      />
    </>
  )
}
